import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Ward } from '../pages/admin/ward-manage/ward';
import { ApiService } from './api.service';
import { environment } from 'src/environments/environment';
import { SubdomainService } from './subdomain.service';
@Injectable({
  providedIn: 'root',
})
export class WardService {
  private baseURL = `${environment.apiBaseUrl}/api/ward/`;
  constructor(
    private apiService: ApiService,
    private httpClient: HttpClient,
    private subdomainService: SubdomainService
  ) {}

  doLoad = async (
    paramObject?: any,
    location?: any
  ): Promise<Observable<any>> => {
    let queryParams: string;
    let url = `${this.baseURL}${location}`;
    if (paramObject) {
      queryParams = new URLSearchParams(paramObject).toString();
      url = `${url}?${queryParams}`;
    }
    return this.httpClient.get<any>(url);
  };

  doPost = (paramObject: any, body: any, location: string): Observable<any> => {
    let queryParams: string;
    let url = `${this.baseURL}${location}`;
    if (paramObject) {
      queryParams = new URLSearchParams(paramObject).toString();
      url = `${url}?${queryParams}`;
    }
    body.subdomain = this.subdomainService.getSubdomain();
    return this.httpClient.post<any>(url, body);
  };

  getWardList = (): Observable<any> => {
    let body = {
      subdomain: this.subdomainService.getSubdomain(),
    };
    return this.httpClient.post(`${this.baseURL}getAllWardAllInfo`, body);
  };

  getWardListWithAssessmentCounts = (): Observable<any> => {
    let body = {
      subdomain: this.subdomainService.getSubdomain(),
    };
    return this.httpClient.post(`${this.baseURL}getWardAssessmentCounts`, body);
  };

  createWard = (ward: Ward): Observable<any> => {
    return this.doPost({}, ward, 'create');
  };

  updateWard = (ward: Ward): Observable<any> => {
    return this.doPost({}, ward, 'update');
  };

  deleteWard = async (wardId: number) => {
    return this.httpClient.delete<any>(`${this.baseURL}delete/${wardId}`);
  };

  batchDeleteWardData = async (wardId: number) => {
    return this.httpClient.delete<any>(`${this.baseURL}batch-delete/${wardId}`);
  };
}
